<mat-toolbar style="font-weight: lighter;padding-right: 16px;background-color: white;" class="no-print">
<!--  <button mat-button class="hamburger" (click)="hamburgerClick.emit()">-->
<!--    <span class="mat-button-wrapper"> <mat-icon>dehaze</mat-icon> </span>-->
<!--  </button>-->
  <span class="leading-space"></span>
  <div style="width: 160px">
    <img src="./assets/TOSAKA_logo_brown.png"
         style="margin-right: 20px; margin-bottom: 3px; height: 30px; vertical-align: middle;"
         alt="TOSAKA">
  </div>
  <span class="fill-remaining-space"></span>

  <ng-container *ngIf="sessionService.session.nabelAdmin">

    <button mat-icon-button [matMenuTriggerFor]="settei" matTooltip="設定" class="icon-button">
      <mat-icon>settings</mat-icon>
    </button>

    <mat-menu class="white-background-menu" #settei="matMenu">
      <button mat-menu-item [matMenuTriggerFor]="systemKanriForNabel">
        システム管理（ナベル向け）
      </button>
    </mat-menu>

    <mat-menu class="white-background-menu" #systemKanriForNabel="matMenu">
      <a mat-menu-item routerLink="/admin/jigyousho">
        <span>事業所登録</span>
      </a>
    </mat-menu>

  </ng-container>

  <ng-container>

    <button mat-icon-button [matMenuTriggerFor]="inChargeShinsei" matTooltip="通知" class="icon-button">
      <!--   https://stackoverflow.com/a/38057574   -->
      <ng-container *ngIf="(alertObservable | async) as alerts">
        <mat-icon matBadge="{{alerts.length}}" matBadgeColor="warn"
                  [matBadgeHidden]="alerts.length < 1">notifications</mat-icon>
      </ng-container>
    </button>
    <mat-menu #inChargeShinsei="matMenu">
      <ng-container *ngIf="(alertObservable | async) as alerts">
        <ng-container *ngIf="alerts.length > 0">
          <div class="tsuuchi" *ngFor="let alert of alerts"
               (click)="redirectTo(ALERT + '/notifications')">
          <span class="title">
            {{commonService.getName(masterService.keishaMaster, alert.keishaId, 'farmKeisha')}}
            <!--            <br>-->
            <!--            {{alert.timeStamp.toDate() | timestamp: 'yyyy-MM-dd HH:mm'}}-->
            <span *ngIf="alert.shiyoulotName"><br>{{alert.shiyoulotName}}</span>
          </span>
            <br>
            <span class="content">
            {{alert.alertAbstract}}
          </span>
          </div>
        </ng-container>
        <ng-container *ngIf="alerts.length === 0">
          <div class="tsuuchi">
          <span class="content">
            通知はありません。
          </span>
          </div>
        </ng-container>
      </ng-container>
    </mat-menu>
  </ng-container>
</mat-toolbar>
